/* eslint-disable eqeqeq */
import { SearchOutlined } from "@ant-design/icons";
import {
  Button,
  Divider,
  Input,
  Popconfirm,
  Select,
  Switch,
  Table,
} from "antd";
import Modal from "antd/lib/modal/Modal";
import axios from "axios";
import ExcelJS from "exceljs";
import moment from "moment";
import QRCode from "qrcode.react";
import React from "react";
import { renderToString } from "react-dom/server";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import OrderHistory from "../components/OrderHistory";
import { Capitalize, ConvertDateTime, ConvertOrderLocation } from "../helper";
import {
  CopyOrder,
  DeleteOrder,
  DeleteSingleMachine,
  GetAllOrdersByType,
  GetMachineListFromOrderById,
  GetMovableMachines,
  SwitchMachines,
} from "../services/OrderService";

const getBase64FromUrl = async (url) => {
  const data = await fetch(url);
  const blob = await data.blob();
  return new Promise((resolve) => {
    const reader = new FileReader();
    reader.readAsDataURL(blob);
    reader.onloadend = () => {
      const base64data = reader.result;
      resolve(base64data);
    };
  });
};

function exportWithExcel(data) {
  const workbook = new ExcelJS.Workbook();
  const sheet = workbook.addWorksheet("My Sheet");
  sheet.properties.defaultRowHeight = 100;

  sheet.columns = [
    {
      header: "Sipariş Numarası",
      key: "order_no",
      width: 10,
    },
    { header: "Müşteri Adı", key: "customer", width: 32 },
    { header: "Makinenin Özellikleri", key: "description", width: 32 },
    { header: "Sipariş Alan", key: "order_tooker", width: 32 },
    { header: "Planlama Tarihi", key: `planned_date`, width: 32 },
    { header: "Miktar", key: `quantity`, width: 32 },

    {
      header: "QR",
      key: "qr_code",
      width: 30,
    },
  ];

  const configFile = JSON.parse(localStorage.getItem("config") ?? "{}");

  const promise = Promise.all(
    data.map(async (item, index) => {
      const rowNumber = index + 1;
      const getConfigText = (field, type) =>
        configFile?.[field]?.find((b) => b.type === type)?.text;
      const mixerText = getConfigText("mixer_type", item.mixer_type);

      const order_details = [
        item.brand,
        getConfigText("brand", item.brand),
        getConfigText("chassis_color", item.chassis_color),
        getConfigText("commander", item.commander),
        getConfigText("arm_type", item.arm_type),
        item.arm_length,
        item.production_unit,
        item.caldron_color,
        getConfigText("caldron_type", item.caldron_type),
        getConfigText("cooler_type", item.cooler_type),
        item.fan_radius,
        item.fan_type,
        getConfigText("pump", item.pump),
        mixerText || item.mixer_type,
        item.meme_distance,
        getConfigText("meme_type", item.meme_type),
        item.tank_size,
        item.type,
        getConfigText("tow_type", item.tow_type),
        item.alt_features,
        item.year,
      ]
        .filter(
          (value) =>
            value !== null &&
            value !== undefined &&
            String(value).trim() !== "",
        )
        .join(", ");

      sheet.addRow({
        order_no: item?.order_no,
        customer: item?.customer,
        description: order_details,

        order_tooker: item?.order_tooker,
        planned_date: item?.planned_date,
        quantity:
          item?.order_amount - item?.pending_amount + "/" + item?.order_amount,
      });
      let qrCodeValue = item.serial_number + "," + item.description;

      let url =
        await `https://api.qrserver.com/v1/create-qr-code/?size=150x150&data=${qrCodeValue}`;

      const res = await getBase64FromUrl(url);

      const imageId2 = workbook.addImage({
        base64: res,
        extension: "jpg",
      });

      sheet.addImage(imageId2, {
        tl: { col: 6, row: rowNumber },
        ext: { width: 100, height: 100 },
      });
    }),
  );

  promise.then(() => {
    workbook.xlsx.writeBuffer().then(function (data) {
      const blob = new Blob([data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      const url = window.URL.createObjectURL(blob);
      const anchor = document.createElement("a");
      anchor.href = url;
      anchor.download = "download.xlsx";
      anchor.click();
      window.URL.revokeObjectURL(url);
    });
  });
}
export function renderProperties(key, value) {
  if (value) {
    return (
      <div style={{ display: "flex" }}>
        <p style={{ fontWeight: "bold", marginRight: "5px" }}>{key}:</p>
        <p>{value}</p>
      </div>
    );
  }
}

class OrderScreen extends React.Component {
  constructor(props) {
    super(props);
    this.route =
      this.props.location?.pathname.split("/")[
        this.props.location?.pathname.split("/").length - 1
      ];
    this.renderOrderDetails = this.renderOrderDetails.bind(this);
  }

  configFile = JSON.parse(localStorage.getItem("config") ?? "{}");

  renderOrderDetails(record) {
    return Object.keys(this.state.orderDetails).map((detail) => {
      return detail == record.id
        ? this.state.orderDetails[detail]?.map((detail) => {
            return (
              <>
                <div
                  style={{
                    width: "80%",
                    marginTop: 30,
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "space-between",
                  }}
                >
                  {renderProperties("TCKN No", record.tckn)}
                  <div>
                    {renderProperties(
                      "Seri No",
                      Capitalize(detail.serial_number),
                    )}
                    {renderProperties("Şase No", Capitalize(detail.chassis_no))}
                    {renderProperties("Sas No", Capitalize(detail.sas_no))}
                    {renderProperties(
                      "Pompa Seri No",
                      Capitalize(detail.pump_serial),
                    )}
                    {renderProperties(
                      "Bulunduğu Konum",
                      ConvertOrderLocation(detail.location) +
                        (detail.comment ? ` (${detail.comment})` : " "),
                    )}
                    {renderProperties(
                      "Son İşlem Tarihi",
                      ConvertDateTime(detail.row_created_date),
                    )}
                    {renderProperties(
                      "Planlama Tarihi",
                      ConvertDateTime(detail.planned_date),
                    )}
                  </div>
                  <div style={{ width: "min-content" }}>
                    {detail.location !== "teslimat" &&
                    detail.location !== "iptal" &&
                    this.props.user.role == "admin" ? (
                      <Button
                        style={{ marginBottom: 10, width: "100%" }}
                        type="primary"
                        onClick={() => {
                          this.setState({
                            orderModalVisible: true,
                            orderSelected: {
                              serial_number: detail.serial_number,
                              order_id: record.id,
                            },
                          });
                        }}
                      >
                        Siparişi Kaydır
                      </Button>
                    ) : null}
                    <Button
                      style={{ marginBottom: 10, width: "100%" }}
                      onClick={() => {
                        let qrCodeValue =
                          detail.serial_number + "," + record.description;
                        this.printQRCode(qrCodeValue, detail.serial_number);
                      }}
                    >
                      Qr Kodu Yazdır
                    </Button>

                    <Button
                      style={{ marginBottom: 10, width: "100%" }}
                      onClick={() => {
                        this.setState({
                          historyModalVisible: true,
                          historyModalId: detail.id,
                          orderSelected: {
                            serial_number: detail.serial_number,
                            order_id: record.id,
                          },
                        });
                      }}
                    >
                      İşlem Geçmişini Göster
                    </Button>
                    {detail.test_comment ? (
                      <Button
                        block
                        onClick={() => {
                          axios
                            .get("./finalkontrolformu.xlsx", {
                              responseType: "blob",
                            })
                            .then((res) => {
                              const FileSaver = require("file-saver");

                              var reader = new FileReader();
                              reader.readAsArrayBuffer(res.data);
                              reader.onload = function (e) {
                                const workbook = new ExcelJS.Workbook();
                                workbook.xlsx.load(e.target.result).then(() => {
                                  var worksheet = workbook.getWorksheet(1);
                                  var row = worksheet.getRow(58);
                                  row.getCell(1).value = detail.test_comment; // A5's value set to 5
                                  row.commit();

                                  var row2 = worksheet.getRow(8);
                                  row2.getCell(1).value = detail.serial_number;
                                  row2.getCell(5).value = detail.test_manager; // A5's value set to 5
                                  row2.getCell(6).value = ConvertDateTime(
                                    detail.test_date,
                                  ); // A5's value set to 5
                                  row2.commit();

                                  workbook.xlsx.writeBuffer().then((buffer) => {
                                    const blob = new Blob([buffer], {
                                      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8",
                                    });

                                    FileSaver.saveAs(blob, "deneme.xlsx");
                                  });
                                });
                              };
                            });
                        }}
                      >
                        Test Raporu
                      </Button>
                    ) : null}
                    {this.props.user?.role == "admin" &&
                    detail.location !== "iptal" ? (
                      <Popconfirm
                        title="Bu makinayı silmek istediğinizden emin misiniz? Bu işlem geri alınamaz"
                        onConfirm={() =>
                          DeleteSingleMachine(detail.id).then(() => {
                            GetMachineListFromOrderById(record.id).then(
                              (orderDetails) => {
                                this.setState({
                                  orderDetails: {
                                    ...this.state.orderDetails,
                                    [record.id]: orderDetails,
                                  },
                                });
                              }
                            );
                            this.GetOrders();
                          })
                        }
                        okText="Evet"
                        cancelText="Hayır"
                      >
                        <Button
                          danger
                          block
                          style={{ marginBottom: 10 }}
                          type="primary"
                        >
                          Makinayı Sil
                        </Button>
                      </Popconfirm>
                    ) : null}
                  </div>
                </div>
                <Divider />
              </>
            );
          })
        : null;
    });
  }

  getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
    }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={(node) => {
            this.searchInput = node;
          }}
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={(e) =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={() =>
            this.handleSearch(selectedKeys, confirm, dataIndex)
          }
          style={{
            width: 188,
            marginBottom: 8,
            display: "block",
          }}
        />
        <Button
          type="primary"
          onClick={() => this.handleSearch(selectedKeys, confirm, dataIndex)}
          size="small"
          style={{ width: 90, marginRight: 8 }}
        >
          Bul
        </Button>
        <Button
          onClick={() => this.handleReset(clearFilters)}
          size="small"
          style={{ width: 90 }}
        >
          Sıfırla
        </Button>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined
        type="search"
        style={{ color: filtered ? "#1890ff" : undefined }}
      />
    ),
    onFilter: (value, record) =>
      record[dataIndex]
        ?.toString()
        ?.toLowerCase()
        ?.includes(value.toLowerCase()),
    onFilterDropdownOpenChange: (visible) => {
      if (visible) {
        setTimeout(() => this.searchInput.select());
      }
    },
    render: (text) => text,
  });

  handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    this.setState({
      searchText: selectedKeys[0],
      searchedColumn: dataIndex,
    });
  };

  handleReset = (clearFilters) => {
    clearFilters();
    this.setState({ searchText: "" });
  };

  state = {
    movableMachines: [],
    orderModalVisible: false,
    keepMachineDetails: false,
    csvdata: [
      [
        "Seri No",
        "Sipariş No",
        "Sipariş Tarihi",
        "Müşteri",
        "Telefon",
        "Adres",
        "Sipariş Alan",
        "Durum",
      ],
    ],
    orderDetails: {},
    loading: true,
    size: "small",
    top: "none",
    bottom: "bottomRight",
    ellipsis: true,
    data: [],
    filteredData: [],
    columns: [
      {
        title: "Sipariş No",
        dataIndex: "order_no",
        sorter: (a, b) => a.order_no.localeCompare(b.order_no),
        ...this.getColumnSearchProps("order_no"),
      },
      {
        title: "Müşteri",
        dataIndex: "customer",
        sorter: (a, b) => a.customer.localeCompare(b.customer),
        ...this.getColumnSearchProps("customer"),
      },
      {
        title: "Telefon No",
        dataIndex: "phone_number",
        ...this.getColumnSearchProps("phone_number"),
      },
      {
        title: "Lokasyon",
        dataIndex: "address",
        ...this.getColumnSearchProps("address"),
      },
      {
        title: "Seri No",
        dataIndex: "serial_number",
        sorter: (a, b) => a.serial_number.localeCompare(b.serial_number),
        ...this.getColumnSearchProps("serial_number"),
      },
      {
        title: "Ürün Tipi",
        dataIndex: "production_unit",
        sorter: (a, b) => a.production_unit.localeCompare(b.production_unit),
        ...this.getColumnSearchProps("production_unit"),
        render: (text) => <td>{Capitalize(text)}</td>,
      },
      {
        title: "Miktar",
        sorter: (a, b) => a.pending_amount - b.pending_amount,
        ...this.getColumnSearchProps("order_amount"),
        render: (text, order) => (
          <td>
            {String(order.order_amount - order.pending_amount) +
              "/" +
              order.order_amount}
          </td>
        ),
      },
      {
        title: "Sipariş Tarihi",
        dataIndex: "date",
        defaultSortOrder: "descend",
        sorter: (a, b) =>
          moment(a.date, "D MMMM YYYY, HH:mm").unix() -
          moment(b.date, "D MMMM YYYY, HH:mm").unix(),
        ...this.getColumnSearchProps("date"),
        render: (text) => <td>{text}</td>,
      },

      {
        title: "Sipariş Alan",
        dataIndex: "order_tooker",
        sorter: (a, b) => a.order_tooker.localeCompare(b.order_tooker),
        ...this.getColumnSearchProps("order_tooker"),
        render: (text) => <td>{text.toUpperCase()}</td>,
      },
      {
        title: "Planlanan Tarih",
        dataIndex: "planned_date",
        sorter: (a, b) =>
          moment(a.planned_date, "D MMMM YYYY, HH:mm").unix() -
          moment(b.planned_date, "D MMMM YYYY, HH:mm").unix(),
        ...this.getColumnSearchProps("planned_date"),
        render: (text) => (
          <td>{text ? ConvertDateTime(text, "D MMMM YYYY") : "Planlanmadı"}</td>
        ),
      },
    ],
  };

  printQRCode(value, serialNumber) {
    let printWindow = window.open("", "", "height=1024, width=1024");

    let svg = renderToString(
      <div style={{ width: "50mm", height: "64mm" }}>
        <QRCode
          value={value}
          style={{ height: "44mm", width: "44mm", margin: "3mm" }}
          renderAs="svg"
        />
        <p style={{ margin: 10 }}>{serialNumber}</p>
      </div>,
    );
    printWindow?.document.write(String(svg));

    printWindow.document.body.style.margin = 0;
    printWindow?.document.close();
    printWindow?.print();
  }

  componentDidUpdate(prevProps) {
    if (
      this.props.isFinishedOrders !== prevProps.isFinishedOrders ||
      this.props.isCancelledOrders !== prevProps.isCancelledOrders
    ) {
      this.GetOrders();
    }
  }

  GetOrders() {
    this.props.isFinishedOrders &&
      GetAllOrdersByType(this.route).then((result) => {
        // item?.order_amount - item?.pending_amount + "/" + item?.order_amount
        let dateModifiedData = result?.map((order) => {
          const date = new Date(order.date);
          order.date = moment(date).format("D MMMM YYYY, HH:mm");
          return order;
        });
        let filteredDataForExcel = result
          ?.map((order) => {
            order.date = moment(order.date).format("D MMMM YYYY, HH:mm");
            return order;
          })
          .filter(
            (item) =>
              item?.order_amount - item?.pending_amount !== item?.order_amount,
            // item.location === "onaybekliyor" || item.location === "planlandı"
          );

        this.setState({
          data: dateModifiedData,
          filteredData: filteredDataForExcel,
          loading: false,
        });
      });
  }

  onChange = (checked) => {
    this.setState({ keepMachineDetails: checked ? true : false });
  };

  componentDidMount = () => {
    this.GetOrders();
    GetMovableMachines().then((machines) => {
      if (machines) {
        this.setState({ movableMachines: machines });
      }
    });
  };
  searchInput;

  render() {
    const state = this.state;

    return (
      <div
        style={{
          width: "100%",
          maxWidth: "100%",
          height: "100%",
          maxHeight: "100%",
          display: "flex",
          flexDirection: "column",
        }}
      >
        <Table
          rowKey={(row) => "key" + row.id}
          size="small"
          loading={this.state.loading}
          expandable={{
            expandedRowRender: (record) => (
              <div
                key={"keyexpandable " + record.id}
                style={{ marginLeft: "3rem" }}
              >
                {renderProperties("TCKN No", record.tckn)}
                {renderProperties("Ürün", record.description)}
                {renderProperties("Tarih", record.date)}
                {renderProperties(
                  "Marka",
                  this.configFile.brand.filter(
                    (b) => b.type === record.brand,
                  )[0]?.text,
                )}
                {renderProperties("Sipariş No", record.order_no)}
                {renderProperties(
                  "Sipariş Miktarı",
                  String(record.order_amount),
                )}
                {renderProperties(
                  "Tip",
                  this.configFile.type.filter((b) => b.type === record.type)[0]
                    ?.text
                    ? this.configFile.type.filter(
                        (b) => b.type === record.type,
                      )[0]?.text
                    : this.configFile.machine_type.filter(
                        (b) => b.type === record.type,
                      )[0]?.text,
                )}
                {renderProperties(
                  "Fan Tipi",
                  this.configFile.cooler_type.filter(
                    (b) => b.type === record.cooler_type,
                  )[0]?.text,
                )}
                {renderProperties(
                  "Kazan Boyutu",
                  record.tank_size ? record.tank_size + " LT" : null,
                )}
                {renderProperties(
                  "Kazan Materyali",
                  this.configFile.caldron_material.filter(
                    (b) => b.type === record.caldron_material,
                  )[0]?.text,
                )}
                {renderProperties(
                  "Pompa",
                  this.configFile.pump.filter((b) => b.type === record.pump)[0]
                    ?.text,
                )}
                {renderProperties("Model Yılı", record.year)}
                {renderProperties(
                  "Meme Tipi",
                  this.configFile.meme_type.filter(
                    (b) => b.type === record.meme_type,
                  )[0]?.text,
                )}
                {renderProperties(
                  "Mixer Tipi",
                  this.configFile.mixer_type.filter(
                    (b) => b.type === record.mixer_type,
                  )[0]?.text ||
                    record.mixer_type ||
                    "-",
                )}
                {renderProperties("Meme Aralığı", record.meme_distance)}
                {renderProperties(
                  "Çeki Tipi",
                  this.configFile.tow_type.filter(
                    (b) => b.type === record.tow_type,
                  )[0]?.text,
                )}
                {renderProperties(
                  "Kol Tipi",
                  this.configFile.arm_type.filter(
                    (b) => b.type === record.arm_type,
                  )[0]?.text,
                )}
                {renderProperties("Kol Uzunluğu", record.arm_length)}
                {renderProperties(
                  "Şase Rengi",
                  this.configFile.chassis_color.filter(
                    (b) => b.type === record.chassis_color,
                  )[0]?.text,
                )}
                {renderProperties(
                  "Kazan Rengi",
                  Capitalize(record.caldron_color),
                )}
                {renderProperties(
                  "Kazan Tipi",
                  this.configFile.caldron_type.filter(
                    (b) => b.type === record.caldron_type,
                  )[0]?.text,
                )}
                {renderProperties(
                  "Kumanda",
                  this.configFile.commander.filter(
                    (b) => b.type === record.commander,
                  )[0]?.text,
                )}
                {renderProperties("Alternatif Özellikler", record.alt_features)}
                <Button
                  style={{ marginRight: "10px" }}
                  type="primary"
                  onClick={() => {
                    GetMachineListFromOrderById(record.id).then(
                      (orderDetails) => {
                        this.setState({
                          orderDetails: {
                            ...this.state.orderDetails,
                            [record.id]: orderDetails,
                          },
                        });
                      },
                    );
                  }}
                >
                  Detayları Göster
                </Button>
                {this.props.user?.role == "admin" ? (
                  <Popconfirm
                    title="Bu siparişi stok olarak kopyalamak  istediğinizden emin misiniz?"
                    onConfirm={() => CopyOrder(record.serial_number)}
                    okText="Evet"
                    cancelText="Hayır"
                  >
                    <Button style={{ marginRight: "10px" }} type="primary">
                      STOK Olarak Kopyala
                    </Button>
                  </Popconfirm>
                ) : null}

                {this.renderOrderDetails(record)}
                {record.status !== "cancelled" &&
                this.props.user?.role == "admin" &&
                !this.props.isFinishedOrders ? (
                  <Popconfirm
                    title="Bu siparişi iptal etmek istediğinizden emin misiniz?"
                    onConfirm={() => DeleteOrder(record.id)}
                    okText="Evet"
                    cancelText="Hayır"
                  >
                    <Button
                      danger
                      style={{ marginBottom: 10, marginRight: 10 }}
                      type="primary"
                    >
                      Siparişi İptal Et
                    </Button>
                  </Popconfirm>
                ) : null}

                <Link
                  style={{
                    display:
                      record.order_amount !== record.pending_amount && "none",
                    color: "white",
                    marginBottom: 10,
                    backgroundColor: "#1677ff",
                    padding: "8px",
                    borderRadius: "6px",
                  }}
                  to={{
                    pathname: `/editOrder/${record.serial_number}`,
                  }}
                >
                  Düzenle
                </Link>
              </div>
            ),
          }}
          pagination={{ defaultPageSize: 10, position: ["bottomRight"] }}
          columns={this.state.columns}
          dataSource={state.data}
        />

        <Button
          loading={this.state.loading}
          style={{
            width: "120px",
            display: "flex",
            alignSelf: "end",
            marginRight: "2rem",
          }}
          type="primary"
          onClick={() => exportWithExcel(state?.filteredData)}
        >
          Excel'e Aktar
        </Button>

        <Modal
          title={
            this.state.orderSelected?.serial_number + " Seri Numaralı Makine."
          }
          open={this.state.orderModalVisible}
          onOk={() => {
            this.setState({ orderModalVisible: false });
            SwitchMachines({
              order1: this.state.selectedToMove,
              order2: this.state.orderSelected,
              keepMachineDetails: this.state.keepMachineDetails,
            });
          }}
          onCancel={() => {
            this.setState({ orderModalVisible: false });
          }}
        >
          <p>Lütfen değişim yapmak istediğiniz makineyi seçin.</p>
          <Select
            showSearch
            optionFilterProp="children"
            filterOption={(input, option) =>
              option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
            }
            style={{ width: "100%" }}
            onSelect={(value) => {
              this.setState({
                selectedToMove: {
                  serial_number: value.split(" ")[0],
                  order_id: Number.parseInt(value.split(" ")[1]),
                },
              });
            }}
            placeholder="Lütfen bir makine seçin"
            defaultActiveFirstOption={true}
          >
            {this.state.movableMachines?.map((machine) => {
              return (
                <Select.Option
                  key={machine.id}
                  value={machine.serial_number + " " + machine.order_id}
                >
                  {machine.serial_number +
                    " " +
                    machine.customer +
                    " " +
                    Capitalize(machine.location)}
                </Select.Option>
              );
            })}
          </Select>
          <div style={{ marginTop: "2rem", display: "flex", gap: "1rem" }}>
            <span>Sipariş Detayını Değiştir</span>
            <Switch onChange={this.onChange} />
            <span>Sipariş Detayını Koru (STOK)</span>
          </div>
        </Modal>
        {this.state.historyModalVisible ? (
          <OrderHistory
            isVisible={this.state.historyModalVisible}
            machine_id={this.state.historyModalId}
            serial_number={this.state.orderSelected?.serial_number}
            setIsVisible={(visible) =>
              this.setState({ historyModalVisible: visible })
            }
          />
        ) : null}
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => ({
  user: state.auth.user,
});

export default connect(mapStateToProps)(OrderScreen);
